import removeMarkdown from 'remove-markdown';
import { IChat, IChatMessage } from './BeeChatClient';
import { stripCitations } from './stripCitations';

/** How a conversation is listed and shown, the same for family and agency Bea. */
export class BeaChatFormatter {
    /** A generated title, else the first thing asked, else a placeholder. */
    getTitle = (chat: IChat): string => {
        if (chat.title) {
            return chat.title;
        }
        const firstQuestion = chat.messages.find(message => message.role === 'user');
        return firstQuestion ? removeMarkdown(firstQuestion.content) : 'New conversation';
    };

    /** The conversation as shown: Bea's welcome first, once, dated with the first message. */
    withWelcome = ({ messages, welcome }: { messages: IChatMessage[]; welcome: string }): IChatMessage[] => {
        if (messages.length > 0 && messages[0].role === 'assistant' && messages[0].content === welcome) {
            return messages;
        }
        const welcomeMessage: IChatMessage = { role: 'assistant', content: welcome, createdAt: messages[0]?.createdAt ?? new Date().toISOString() };
        return [welcomeMessage, ...messages];
    };

    /** Chats as read from the api, with the model's citation markers removed from every message. */
    cleanLoaded = (chats: IChat[]): IChat[] => {
        return chats.map(chat => ({ ...chat, messages: chat.messages.map(message => ({ ...message, content: stripCitations(message.content, false) })) }));
    };
}
